import useIsMobile from '@paradigm/design-system/src/hooks/useIsMobile';
import {
  useLiquidityFilterActions,
  useLiquidityFilterState,
} from '@paradigm/features/src/leaderboard/contexts/liquidity-filter';

import { TabContainer } from '#/components/Leaderboard/shared/components';
import FilterForm from '#/components/Leaderboard/shared/FilterForm';
import FilterModal from '#/components/Leaderboard/shared/FilterModal';
import LiquidityResponsesTable from '#/components/Leaderboard/liquidity/LiquidityResponsesTable';
import { useLiquidityResponsesState } from '@paradigm/features/src/leaderboard/contexts/liquidity-responses-list';

export default function LiquidityResponsesTab() {
  const isMobile = useIsMobile();
  const actions = useLiquidityFilterActions();
  const state = useLiquidityFilterState();
  const { lastUpdatedAt } = useLiquidityResponsesState();

  return (
    <TabContainer data-testid="leaderboard-liquidity-responses-tab">
      {!isMobile && (
        <FilterForm
          lastUpdatedAt={lastUpdatedAt}
          actions={actions}
          state={state}
          hasStrategyField
          filterType="liquidity"
        />
      )}
      <LiquidityResponsesTable />
      <FilterModal
        lastUpdatedAt={lastUpdatedAt}
        actions={actions}
        state={state}
        hasStrategyField
        filterType="liquidity"
      />
    </TabContainer>
  );
}
